module.exports = "pegasus_template/assets/tech/small/6.jpg";